import * as navigation from 'app-level/navigation';
import _ from 'lodash';

import { ParentType } from '__generated__/globalTypes';
import { useFilterConfig } from './portfolioFilters.config';

export function usePortfolioFilters() {
  const assetClass = navigation.usePortfolioAssetClass();

  const filtersConfig = useFilterConfig(assetClass, {
    parentType: ParentType.COMPANY,
  });

  const [currentFilters, setCurrentFilters] = navigation.usePortfolioFilters();
  const { poolFromUrl, setPool } = navigation.usePoolUrl();

  return {
    filtersConfig,
    currentFilters,
    setCurrentFilters,
    poolFromUrl,
    setPool,
  };
}
